import React from "react";
import { useHistory } from "react-router-dom";

import "./style.css";

function Sidebar({ showSidebar, handleSidebarClick }) {
  const history = useHistory();

  return (
    <div className={`sidebar ${showSidebar ? "sidebar__show" : ""}`}>
      <div
        className={`sidebar__body ${showSidebar ? "sidebar__body__show" : ""}`}
      >
        <div className="sidebar__body__menu__list">
          <ul>
            <li onClick={() => handleSidebarClick("home")}>Home</li>
            <li onClick={() => handleSidebarClick("work")}>Work Samples</li>
            <li onClick={() => handleSidebarClick("meet")}>Schedule a meet</li>
          </ul>
        </div>
        {/* <Divider orientation="vertical" flexItem />
                <div>

                </div> */}
      </div>
    </div>
  );
}

export default Sidebar;
